import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NFLookupVendorCustomer } from "../../../../Shared/NewForms/NFLookupVendorCustomer";
import { NFLookupContract } from "../../../../Shared/NewForms/NFLookupContract";
import { NFLookupBankAccount } from "../../../../Shared/NewForms/NFLookupBankAccount";

const IncomingBanksReturnFromAdvanceHolderDetail = () => {
  const { t } = useTranslation();

  return (
    <Row>
      <Col sm={6}>
        <NFLookupBankAccount fieldName="senderBankAccountId" title={t("SenderBankAccount")} required />
      </Col>
      <Col sm={6}>
        <NFLookupVendorCustomer fieldName="vendorCustomerId" title={t("VendorsAndCustomers")} required />
      </Col>
      <Col sm={6}>
        <NFLookupContract fieldName="contractId" title={t("Contract")} />
      </Col>
    </Row>
  );
};

export default IncomingBanksReturnFromAdvanceHolderDetail;
